var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClientPortal3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_341_711)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 24,
    fill: "#73151F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.236 30.7813H45.4387C45.1067 30.7813 44.8387 30.5133 44.8387 30.1813V20.3839C44.8387 20.0519 45.1067 19.7839 45.4387 19.7839C45.7707 19.7839 46.0387 20.0519 46.0387 20.3839V29.5813H55.236C55.568 29.5813 55.836 29.8493 55.836 30.1813C55.836 30.5133 55.568 30.7813 55.236 30.7813Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.236 65.2239H19.8C19.468 65.2239 19.2 64.9559 19.2 64.6239V20.3839C19.2 20.0519 19.468 19.7839 19.8 19.7839H45.4387C45.5973 19.7839 45.7507 19.8466 45.8627 19.9599L55.66 29.7573C55.772 29.8693 55.836 30.0226 55.836 30.1813V64.6226C55.836 64.9546 55.568 65.2226 55.236 65.2226V65.2239ZM20.4 64.0239H54.6347V30.4306L45.1893 20.9853H20.4V64.0239Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.288 25.8826H25.2013C24.8693 25.8826 24.6013 25.6146 24.6013 25.2826C24.6013 24.9506 24.8693 24.6826 25.2013 24.6826H38.288C38.62 24.6826 38.888 24.9506 38.888 25.2826C38.888 25.6146 38.62 25.8826 38.288 25.8826Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.288 30.1707H25.2013C24.8693 30.1707 24.6013 29.9027 24.6013 29.5707C24.6013 29.2387 24.8693 28.9707 25.2013 28.9707H38.288C38.62 28.9707 38.888 29.2387 38.888 29.5707C38.888 29.9027 38.62 30.1707 38.288 30.1707Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5173 59.5574C30.5986 59.5574 24.9706 53.9294 24.9706 47.0108C24.9706 40.0921 30.5986 34.4641 37.5173 34.4641C44.436 34.4641 50.064 40.0921 50.064 47.0108C50.064 53.9294 44.436 59.5574 37.5173 59.5574ZM37.5173 35.6628C31.26 35.6628 26.1706 40.7534 26.1706 47.0094C26.1706 53.2654 31.2613 58.3561 37.5173 58.3561C43.7733 58.3561 48.864 53.2654 48.864 47.0094C48.864 40.7534 43.7733 35.6628 37.5173 35.6628Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.16 51.6839C36.828 51.6839 36.56 51.4159 36.56 51.0839V40.8119C36.56 40.4799 36.828 40.2119 37.16 40.2119C37.492 40.2119 37.76 40.4799 37.76 40.8119V51.0839C37.76 51.4159 37.492 51.6839 37.16 51.6839Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.056 45.4252C32.9 45.4252 32.744 45.3652 32.6267 45.2452C32.3947 45.0079 32.3987 44.6279 32.636 44.3972L36.7387 40.3852C36.976 40.1532 37.356 40.1572 37.5867 40.3946C37.8187 40.6319 37.8147 41.0119 37.5774 41.2426L33.4747 45.2546C33.3574 45.3692 33.2067 45.4252 33.0547 45.4252H33.056Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2627 45.4252C41.112 45.4252 40.96 45.3679 40.8427 45.2546L36.74 41.2426C36.5027 41.0106 36.4987 40.6306 36.7307 40.3946C36.9627 40.1572 37.3427 40.1532 37.5787 40.3852L41.6814 44.3972C41.9187 44.6292 41.9227 45.0092 41.6907 45.2452C41.5734 45.3652 41.4174 45.4252 41.2614 45.4252H41.2627Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4826 53.8266H31.8373C31.5053 53.8266 31.2373 53.5586 31.2373 53.2266V50.1813C31.2373 49.8493 31.5053 49.5813 31.8373 49.5813C32.1693 49.5813 32.4373 49.8493 32.4373 50.1813V52.6266H41.8826V50.1813C41.8826 49.8493 42.1506 49.5813 42.4826 49.5813C42.8146 49.5813 43.0826 49.8493 43.0826 50.1813V53.2266C43.0826 53.5586 42.8146 53.8266 42.4826 53.8266Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2 25.7732H50.4027C50.0707 25.7732 49.8027 25.5052 49.8027 25.1732V15.3759C49.8027 15.0439 50.0707 14.7759 50.4027 14.7759C50.7347 14.7759 51.0027 15.0439 51.0027 15.3759V24.5732H60.2C60.532 24.5732 60.8 24.8412 60.8 25.1732C60.8 25.5052 60.532 25.7732 60.2 25.7732Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2 60.2158H55.3013C54.9693 60.2158 54.7013 59.9478 54.7013 59.6158C54.7013 59.2838 54.9693 59.0158 55.3013 59.0158H59.6V25.4224L50.1547 15.9771H25.3653V20.3851C25.3653 20.7171 25.0973 20.9851 24.7653 20.9851C24.4333 20.9851 24.1653 20.7171 24.1653 20.3851V15.3771C24.1653 15.0451 24.4333 14.7771 24.7653 14.7771H50.404C50.5627 14.7771 50.716 14.8398 50.828 14.9531L60.6253 24.7504C60.7373 24.8624 60.8013 25.0158 60.8013 25.1744V59.6158C60.8013 59.9478 60.5333 60.2158 60.2013 60.2158H60.2Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_341_711"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientPortal3);
export default __webpack_public_path__ + "static/media/ClientPortal3.f43ca93e5db4d296939244724660370a.svg";
export { ForwardRef as ReactComponent };